import React from "react";

const faqs = [
    {
      q: "How many days is the course?",
      a: "Our flagship course runs 25 working days. Specialized modules run 7–15 days."
    },
    {
      q: "What are the fees?",
      a: "Fees vary by module. Contact us for the latest schedule. EMI options are available."
    },
    {
      q: "Do you provide hostel?",
      a: "Yes, we assist outstation students with affordable PG accommodations near the institute."
    },
    {
      q: "Is placement guaranteed?",
      a: "95% of our students are placed or self-employed. We provide interview training and shop setup guidance."
    },
    {
      q: "Do I get a certificate?",
      a: "Yes, an ISO-certified completion certificate plus a verified digital badge you can share on LinkedIn."
    },
    {
      q: "Are online classes available?",
      a: "Yes, live online classes with recorded playback and toolkit shipped to your address."
    }
  ];
function Faqdata(){
    return(
            <section className="faq-section scroll-reveal">

            <div className="faq-container scroll-reveal">

                <div className="faq-header scroll-reveal">

                    <div className="faq-subtitle scroll-reveal">
                        FAQ
                    </div>

                    <h2 className="faq-title scroll-reveal">
                        Common Questions
                    </h2>

                </div>

                <div className="faq-list scroll-reveal">

                    {faqs.map((item, index) => (

                        <details className="faq-item" key={index}>

                            <summary>

                                <span className="faq-question">
                                    {item.q}
                                </span>

                                <span className="faq-icon">
                                    +
                                </span>

                            </summary>

                            <p className="faq-answer">
                                {item.a}
                            </p>

                        </details>

                    ))}

                </div>

                <div className="faq-button scroll-reveal">

                    <a href="/faq" className="faq-btn scroll-reveal">
                        See All FAQs →
                    </a>

                </div>

            </div>

            </section>
    )
};
export default Faqdata;